import { WizHDividerComponent } from './wiz-divider/wiz-h-divider.component';
import { WizVDividerComponent } from './wiz-divider/wiz-v-divider.component';
import { WizGrabberComponent } from './wiz-divider/grabber/wiz-grabber.component';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizVgroup } from './wiz-vgroup/wiz-vgroup';
import { WizHgroup } from './wiz-hgroup/wiz-hgroup';
import { WizSpacer } from './wiz-spacer/wiz-spacer';
import { WizGroup } from './wiz-group/wiz-group';
import { WizHgroup2 } from './wiz-hgroup/wiz-hgroup2';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ], // schema custom pour import des selectors dans les subLibs
  declarations: [
    WizGroup,
    WizVgroup,
    WizHgroup, WizHgroup2,
    WizSpacer,
    WizGrabberComponent,
    WizVDividerComponent,
    WizHDividerComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    WizGroup,
    WizVgroup,
    WizHgroup, WizHgroup2,
    WizSpacer,
    WizGrabberComponent,
    WizVDividerComponent,
    WizHDividerComponent
  ]
})
export class WizLayoutModule { }
